module.exports = __webpack_public_path__ + "static/img/qrcode-1.8ce70795.png";